<template>
  <el-button
    v-if="editable && !hasValue"
    class="tft-btn"
    size="mini"
    :title="title"
    :loading="loading"
    :disabled="loading"
    @click.stop="$emit('fill')"
  >
    {{ label }}
  </el-button>
  <button
    v-else-if="hasValue && openable"
    type="button"
    class="tft-text tft-text--open"
    :title="openTitle || title"
    @click.stop="$emit('open')"
  >
    {{ text }}
  </button>
  <span v-else class="tft-text">{{ text }}</span>
</template>

<script lang="ts">
import Vue from 'vue';

/**
 * 对齐 mold 开模推进：日期为空且可编辑时显示为带文案的小按钮，点击由父级填入；
 * 已填则显示「标签 + 日期」文字。
 */
export default Vue.extend({
  name: 'TimeFillTag',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: '' },
    editable: { type: Boolean, default: false },
    title: { type: String, default: '' },
    showValue: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    /** 已填且可点时打开弹窗（对齐 mold 工位） */
    openable: { type: Boolean, default: false },
    openTitle: { type: String, default: '点击查看或修改' },
  },
  computed: {
    hasValue(): boolean {
      return this.value !== '' && this.value != null;
    },
    text(): string {
      if (this.showValue && this.hasValue) return `${this.label} ${String(this.value)}`;
      return this.label;
    },
  },
});
</script>

<style lang="scss" scoped>
.tft-btn {
  margin: 0;
  width: 74px;
  padding: 5px 8px;
  font-size: 11px;
  font-weight: 600;
}

.tft-text {
  font-size: 11px;
  font-weight: 500;
  color: $color-text-regular;
  white-space: nowrap;
}

.tft-text--open {
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  color: $color-primary;

  &:hover {
    text-decoration: underline;
  }
}
</style>
